
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/david",
      function () {
        return require("private-next-pages/david/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/david"])
      });
    }
  